/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CmKatuze } from './cmKatuze.model';
import { BuildingConcernedOwnership } from './buildingConcernedOwnership.model';
import { BudZpochn } from './budZpochn.model';


export interface Building { 
    budId: number;
    budZpochns?: Array<BudZpochn>;
    caobceKod?: number;
    caobceNazev?: string;
    cisloDomovni?: number;
    cmKatuze?: CmKatuze;
    concernedOwnerships?: Array<BuildingConcernedOwnership>;
    countParcelWithoutIdentParcel?: number;
    customName?: string;
    departmentList?: Array<any>;
    docasnaStavba?: string;
    endDate?: string;
    id?: number;
    identParcelId?: number;
    jeSoucasti?: string;
    katuzeKod?: number;
    katuzeNazev?: string;
    kstavby?: string;
    lv?: number;
    name?: string;
    psId?: number;
    startDate: string;
    typbudKod?: number;
    typbudNazev?: string;
    zpvybuKod?: number;
    zpvybuNazev?: string;
}

